import {PrintingSettingsComponent} from "../../components";
export const PrintingSettingsPage = () => {
    return <PrintingSettingsComponent />
}